module.exports = __webpack_public_path__ + "img/8011.a9514b12.gif";